import {Box, Typography, Button} from '@mui/material';
import {bookingPaymentSummaryStyles} from './styles';
import PaymentSummaryBox from '../components/PaymentSummaryBox';
import {formatTime} from '~/utils/helper';
import useHospitalInfo from '~/hooks/useHospitalInfo';
import {CONTACT_US} from '../constant';
import {PaymentSummaryResponse} from './types';

interface BookingPaymentSummaryComponentProps {
  paymentSuccessData?: PaymentSummaryResponse;
}

export default function BookingPaymentSummaryComponent({
  paymentSuccessData,
}: BookingPaymentSummaryComponentProps) {
  const {hospitalInfo} = useHospitalInfo();
  if (!paymentSuccessData) return null;

  const {appointment, payment} = paymentSuccessData;

  const totalAmount = payment?.amount || appointment?.payment?.amount || 250;

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  const handleContactUs = () => {
    window.location.href = CONTACT_US;
    window.location.href = CONTACT_US;
  };
  const handleDiscoverMore = () => {
    if (hospitalInfo?.hospitalURL) {
      window.location.replace(hospitalInfo.hospitalURL);
    }
  };
  return (
    <Box sx={bookingPaymentSummaryStyles.mainContainer}>
      <Box sx={bookingPaymentSummaryStyles.paymentCard}>
        <Typography sx={bookingPaymentSummaryStyles.paymentTitle}>
          Payment completed
        </Typography>

        <Typography sx={bookingPaymentSummaryStyles.descriptionText}>
          Thank you for your payment. Your transaction has been completed
          successfully. <br />
          You will receive a confirmation email shortly.
        </Typography>

        <Typography sx={bookingPaymentSummaryStyles.descriptionText}>
          If you have any questions, feel free to{' '}
          <Typography
            sx={bookingPaymentSummaryStyles.contactLink}
            onClick={handleContactUs}
          >
            contact us
          </Typography>
          .
        </Typography>

        <Button
          sx={bookingPaymentSummaryStyles.discoverButton}
          onClick={handleDiscoverMore}
        >
          Discover more about Stoneygate
        </Button>

        <Box sx={bookingPaymentSummaryStyles.summarySection}>
          <Typography sx={bookingPaymentSummaryStyles.summaryTitle}>
            Your payment summary:
          </Typography>

          <PaymentSummaryBox
            totalAmount={totalAmount}
            items={[
              {
                label: 'Surgery consultation',
                amount: totalAmount,
              },
            ]}
            currency="£"
            headerText="Total paid"
          />

          {appointment && (
            <Box sx={bookingPaymentSummaryStyles.appointmentSection}>
              <Box sx={bookingPaymentSummaryStyles.appointmentRow}>
                <Typography sx={bookingPaymentSummaryStyles.appointmentLabel}>
                  Appointment
                </Typography>
                <Typography sx={bookingPaymentSummaryStyles.appointmentValue}>
                  {appointment?.sub_care_type_name ||
                    'Laser Eye Surgery consultation'}
                </Typography>
              </Box>

              <Box sx={bookingPaymentSummaryStyles.appointmentRow}>
                <Typography sx={bookingPaymentSummaryStyles.appointmentLabel}>
                  Consultant
                </Typography>
                <Typography sx={bookingPaymentSummaryStyles.appointmentValue}>
                  {appointment?.doctor_name || 'No data available'}
                </Typography>
              </Box>

              <Box sx={bookingPaymentSummaryStyles.appointmentRow}>
                <Typography sx={bookingPaymentSummaryStyles.appointmentLabel}>
                  Date
                </Typography>
                <Typography sx={bookingPaymentSummaryStyles.appointmentValue}>
                  {appointment?.date ? formatDate(appointment.date) : '-'}
                </Typography>
              </Box>

              <Box sx={bookingPaymentSummaryStyles.appointmentRow}>
                <Typography sx={bookingPaymentSummaryStyles.appointmentLabel}>
                  Time
                </Typography>
                <Typography sx={bookingPaymentSummaryStyles.appointmentValue}>
                  {appointment?.start_time
                    ? formatTime(appointment.start_time)
                    : '-'}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
